<template>
    <div
      v-if="visible"
      class="base-sidebar omnica-modal-sidebar-overlay"
      @click.self="close"
    >
      <!-- Анимация для выезда sidebar -->
      <transition name="sidebar-slide">
        <aside class="omnica-modal-sidebar omnica-modal-sidebar_size_lg" v-if="visible">
          <!-- Заголовок -->
          <header class="omnica-modal-sidebar__header">
            <div class="omnica-modal-sidebar__header-inner">
              <div class="omnica-modal-sidebar__title">
                <div class="sidebar-head__title">
                    Задачи
                  <span>к заказу {{ orderId }}</span>
                </div>
              </div>
              <button
                role="button"
                aria-label="Esc"
                class="omnica-modal-sidebar__close"
                @click="close"
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="32" class="omnica-popper-target"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
              </button>
            </div>
          </header>
  
          <!-- Основное содержание -->
          <div class="omnica-modal-sidebar__body">
            <div >
                <div class="sidebar-panel">

                    <button type="button" @click="slidebarOpened" class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_has-leading-icon omnica-button_ellipsis">
                       
                        <span class="omnica-button__inner">
                            <span class="omnica-button__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" title="" class="UiIcon-icon-2pR-"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-9h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V8.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11z" fill-rule="evenodd" clip-rule="evenodd"></path></svg></span><span class="omnica-button__text">
                                Создать задачу
                            </span>
                        </span>

                    </button>
                    
                    <div class="hid">

                        <label class="switch">
                            <input type="checkbox" v-model="isChecked">
                            <span class="sliderrr round"></span>
                        </label>
                        Скрыть выполненные
                      
                    </div>


                </div>

                <div class="sidebar-body__inner">
                    <div v-for="task in tasks" :key="task.id" :class="['taskitem', task.viewed ? 'v-' + task.viewed : '']" v-show="!(isChecked && task.viewed === '1' && !task.viewedFalse)"> 
                       
                        <div v-if="task.viewed === '1'"  @click="changeTask(task.id, OrderIdtsk)">
                            <div class="icontask act">
                                <svg>
                                    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.73 15.35L16.35 9.73C16.5341 9.53685 16.5341 9.23315 16.35 9.04L15.82 8.51C15.6256 8.31943 15.3144 8.31943 15.12 8.51L10.38 13.25L8.88 11.76C8.78927 11.6633 8.66259 11.6085 8.53 11.6085C8.39741 11.6085 8.27073 11.6633 8.18 11.76L7.65 12.29C7.55534 12.3839 7.5021 12.5117 7.5021 12.645C7.5021 12.7783 7.55534 12.9061 7.65 13L10.03 15.35C10.1207 15.4467 10.2474 15.5015 10.38 15.5015C10.5126 15.5015 10.6393 15.4467 10.73 15.35Z"/></symbol>
                                    <use xlink:href="#checkmark_circle"></use>
                                </svg>
                            </div>
                        </div>

                        <div v-else>
                            <div :class="['icontask', { act: activeTaskId === task.id }]" @click="updatTask(task.id, OrderIdtsk)"> 
                                <svg :style="{display: activeTaskId === task.id ? 'none' : 'block'}">
                                    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle_empty"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM4 12C4 16.4183 7.58172 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"/></symbol>
                                    <use xlink:href="#checkmark_circle_empty"></use>
                                </svg>
                                <svg :style="{ display: activeTaskId === task.id ? 'block' : 'none' }">
                                    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="checkmark_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.73 15.35L16.35 9.73C16.5341 9.53685 16.5341 9.23315 16.35 9.04L15.82 8.51C15.6256 8.31943 15.3144 8.31943 15.12 8.51L10.38 13.25L8.88 11.76C8.78927 11.6633 8.66259 11.6085 8.53 11.6085C8.39741 11.6085 8.27073 11.6633 8.18 11.76L7.65 12.29C7.55534 12.3839 7.5021 12.5117 7.5021 12.645C7.5021 12.7783 7.55534 12.9061 7.65 13L10.03 15.35C10.1207 15.4467 10.2474 15.5015 10.38 15.5015C10.5126 15.5015 10.6393 15.4467 10.73 15.35Z"/></symbol>
                                    <use xlink:href="#checkmark_circle"></use>
                                </svg>
                            </div>
                        </div>

                        
                        

                        <div class="bubble-item__body" @click="openEditTask(task.id)">
                            <div class="bubble-cont">
                                <div :class="{'complited': task.viewed === '1'}">
                                    {{ task.taskText }} 
                                </div>
                                
                                <div class="bubble-item__comment">
                                        <svg>
                                            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="message_outlined"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H18C20.2091 2 22 3.79086 22 6V14C22 16.2091 20.2091 18 18 18H8C7.19856 17.9847 6.42433 18.2908 5.85 18.85L2.85 21.85C2.75833 21.9451 2.63212 21.9992 2.5 22C2.22386 22 2 21.7761 2 21.5V6C2 3.79086 3.79086 2 6 2ZM20 6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V17.88L4.46 17.46C5.39951 16.5229 6.67301 15.9976 8 16H18C19.1046 16 20 15.1046 20 14V6Z"/></symbol>
                                            <use xlink:href="#message_outlined"></use>
                                        </svg>
                                </div>

                                <div 
                                    v-if="task.viewed !== '1' && isOverdue(task.dueDate)" 
                                    class="erorp"
                                  >
                                    Задача просрочена
                                  </div>


                                
                            </div>

                            <div class="bubble-item__row">
                                <div class="buble-info">

                                    <div>
                                        <svg>
                                            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="order"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.73 7.12L20.59 6.87C20.4094 6.56769 20.1547 6.31643 19.85 6.14L13.14 2.27C12.8362 2.09375 12.4913 2.00062 12.14 2H11.85C11.4987 2.00062 11.1538 2.09375 10.85 2.27L4.14 6.15C3.83697 6.32526 3.58526 6.57697 3.41 6.88L3.27 7.13C3.09375 7.43384 3.00062 7.77874 3 8.13V15.88C3.00062 16.2313 3.09375 16.5762 3.27 16.88L3.41 17.13C3.58979 17.4295 3.84049 17.6802 4.14 17.86L10.86 21.73C11.1623 21.9099 11.5082 22.0033 11.86 22H12.14C12.4913 21.9994 12.8362 21.9063 13.14 21.73L19.85 17.85C20.156 17.6787 20.4087 17.426 20.58 17.12L20.73 16.87C20.9041 16.5653 20.9971 16.221 21 15.87V8.12C20.9994 7.76874 20.9063 7.42384 20.73 7.12ZM11.85 4H12.14L18 7.38L15.9152 8.58224L10.0299 5.05161L11.85 4ZM8.04951 6.19584L13.9329 9.72535L12 10.84L6 7.38L8.04951 6.19584ZM13 19.5L18.85 16.12L19 15.87V9.11L13 12.58V19.5ZM11 12.5L5 9V16L11 19.5V12.5Z"/></symbol>
                                            <use xlink:href="#order"></use>
                                        </svg>
                                    </div>

                                    <div>
                                        {{ orderId }}
                                    </div>

                                </div>
                                <div class="buble-info">

                                    <div>
                                        <svg>
                                            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="account_circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM12 5C13.6569 5 15 6.34315 15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5ZM12 18.9868C14.2151 18.9868 16.2994 17.9384 17.62 16.16C17.8246 15.8609 17.8514 15.4745 17.69 15.15L17.46 14.68C16.9568 13.6531 15.9136 13.0015 14.77 13H9.23C8.07012 13.0012 7.01488 13.671 6.52 14.72L6.31 15.16C6.15251 15.4818 6.17921 15.8633 6.38 16.16C7.70056 17.9384 9.78493 18.9868 12 18.9868Z"/></symbol>
                                            <use xlink:href="#account_circle"></use>
                                        </svg>
                                    </div>

                                    <div>
                                        {{ getPerformer(task.performer) }}
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="dueData" v-if="task.dueDate">До <br>{{ task.dueDate }}</div>
                        

                    </div>


                </div>



  
            </div>
  
          </div>
           <footer class="omnica-modal-sidebar__footer">
                <button
                  type="button"
                  class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_ellipsis"
                  @click="close"
                >
                  Закрыть
                </button>

              </footer>
        </aside>
      </transition>
    </div>
  </template>
  
  <script>
  import axios from 'axios';    
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Russian } from "flatpickr/dist/l10n/ru.js";
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';
  
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      orderId: {
        type: String,
        required: false,
        default: "",
      },
       tasks: {
        type: Array,
        required: true,
      },
      openSidebar: {
        type: Function,
        required: true,
      },
      openEditTask: {
        type: Function,
        required: true
      },
      OrderIdtsk: {
        type: String, 
        required: true
      }
    },
    components: {
      flatPickr,
      vSelect,
          },
    data() {
      return {
        formData: {
          taskOrder:"",
          taskOrderId:"",
          taskText: "",
          tags: "",
          dueDate: "",
          dueTime: "",
          description: "",
          performer: "",
        },
        isHidden: false,
        activeTaskId: null,
        isChecked: false,
        flatpickrConfig: {
          locale: Russian, // Русификация
          enableTime: true, // Включаем выбор времени
          dateFormat: "d.m.Y H:i", // Формат даты
          time_24hr: true, // 24-часовой формат времени
        },
      };
    },
    watch: {
      // Слушаем изменения orderId и обновляем taskOrder
      orderId(newOrderId) {
        this.formData.taskOrder = newOrderId;
      },
       orderIds(newOrderIds) {
        this.formData.taskOrderId = newOrderIds;
      },

    },
    mounted(){
  
       this.user_select();
    },
    methods: {
      getPerformer(performer){
        if(typeof performer === 'string'){
          const performerObject = JSON.parse(performer);
          return performerObject.label;
        }else {
          return performer.label;
        }
      },
      async changeTask(tasId, OrderIdtsk) {
        try { 
            const response = await fetch('https://manager.1akb.by/updateTaskFields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: tasId, viewed: 'false' }) // Обновляем поле viewed
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
            }

            console.log(`Задача ${tasId} отмечена как не просмотренная`); 
            //this.activeTaskId = this.activeTaskId === tasId ? null : tasId;
            
            // Обновляем список задач в OrderEdit
            this.$emit('taskupdate');

            await this.fetchTasksByOrderId(OrderIdtsk);


        } catch (error) {
            console.error("Ошибка при обновлении viewed:", error);
        }
      },
      async updatTask(taskId, OrderIdtsk) {
        try {
            const response = await fetch('https://manager.1akb.by/updateTaskFields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: taskId, viewed: 1 }) // Обновляем поле viewed
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
            }

            console.log(`Задача ${taskId} отмечена как просмотренная`); 
            //this.activeTaskId = this.activeTaskId === taskId ? null : taskId;
          
            // Обновляем список задач в OrderEdit
            this.$emit('taskupdate');
            
            // Загружаем обновленный список
            await this.fetchTasksByOrderId(OrderIdtsk);

        } catch (error) {
            console.error("Ошибка при обновлении viewed:", error);
        }
    },
    async fetchTasksByOrderId(OrderIdtsk) {
      try {
        const response = await fetch(`https://manager.1akb.by/getTasksByOrderId?taskOrderId=${OrderIdtsk}`);

        if (!response.ok) {
          throw new Error(`Ошибка: ${response.statusText}`);
        }

        const dat = await response.json();
        this.tasks = dat;
        

      } catch (error) {
        console.error("Ошибка при получении задач:", error);
      }
    },
      isOverdue(dueDateStr) {
        // Преобразуем строку в формат, понятный для Date
        const isoDate = dueDateStr.replace(
          /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})/,
          '$3-$2-$1T$4:$5'
        );
        const dueDate = new Date(isoDate);
        const now = new Date();
        return dueDate < now;
      },
      getOptionObject(optionsArray, id) {
          const option = optionsArray.find(option => String(option.value) === String(id));
          return option ? { label: option.label, value: option.value } : null;
      },
      close() {
        this.$emit("close");
      },
      user_select() {
        // Установим id текущего пользователя в поле performer
        const currentUser = this.$store.state.user;
        if (currentUser && currentUser.id) {
          this.formData.performer = currentUser.id;
        }
      },
      slidebarOpened(){
        this.close();
        this.openSidebar();
      },
      
    },
  };
  </script>
  
  <style scoped>


.hide-v1 .taskitem.v-1 {
  display: none;
}


  .erorp {
    color: red;
    margin-left: auto;
  }
  /* Задний фон */
  .base-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(45,51,108,.4);
    display: flex;
    justify-content: flex-end;
    z-index: 1000;
  }
  
  /* Сайдбар */
  .omnica-modal-sidebar {
    width: 400px;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*transform: translateX(100%);*/ /* Исходное положение - за экраном */
  }
  
  
  
  .omnica-modal-sidebar {
      background: #fff;
      bottom: 0;
      box-shadow: 0 8px 16px rgb(30 34 72 / 16%);
      display: flex;
      flex-direction: column;
      height: 100%;
      left: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: 416px;
  }
  
  
  .omnica-modal-sidebar_size_lg {
      width: 720px;
  }
  
  
  
  .omnica-modal-sidebar__header {
      align-items: center;
      border-bottom: 1px solid #dee2e6;
      display: flex;
      flex: 0 1 68px;
      justify-content: space-between;
      min-height: 68px;
      padding: 0 24px 0 32px;
      position: relative;
  }
  
  .omnica-modal-sidebar__body {
      flex: 1;
      overflow-y: auto;
  }
  
  .omnica-modal-sidebar__header-inner {
      align-items: center;
      display: flex;
      min-width: 0;
      padding-right: 16px;
  }
  
  .omnica-modal-sidebar__title {
      color: #0d0f1f;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.33333333;
  }
  
  .sidebar-head {
      align-items: center;
      display: flex;
  }
  
  .sidebar-head__title {
      overflow: hidden;
      text-overflow: ellipsis;
  }
  
  .omnica-modal-sidebar__close {
      color: #afb9c3;
      cursor: pointer;
      height: 32px;
      position: absolute;
      right: 17px;
      top: 18px;
      transition: color .25s ease;
      width: 32px;
      background: transparent;
      border: 0px;
  }
  
  
  
  .ps {
      -ms-overflow-style: none;
      overflow: hidden!important;
      overflow-anchor: none;
      touch-action: auto;
      -ms-touch-action: auto;
  }
  
  .ps, .ps * {
      box-sizing: border-box;
  }
  
  .ps {
      position: relative;
  }
  
  .omnica-modal-sidebar__footer {
      background: #f9fafb;
      min-height: 80px;
      padding: 22px 32px;
  }
  
  .sidebar-form__item:first-child {
      margin-top: 0;
  }
  
  .sidebar-form__label {
      color: #8a96a6;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 1.42857143;
      margin-bottom: 4px;
  }
  
  .UiInput-input-3imQ {
      align-items: center;
      display: flex;
      transition: .25s ease;
  }
  
  
  .UiInput-input__area-2i6h {
      background: #fff;
      border: 1px solid #dee2e6;
      border-radius: 6px;
      position: relative;
      width: 100%;
  }
  
  .UiInput-input__area-2i6h {
      height: 36px;
      padding: 0 10px;
  }
  
  .UiTextarea-textarea_default-26FY {
      border: 1px solid #dee2e6;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      min-height: 96px;
  }
  
  .UiTextarea-textarea__area-1IwX {
    background: #fff!important;
      border-radius: 6px!important;
      color: #1e2248!important;
      padding: 8px 16px!important;
  }
  
  
  .omnica-modal-sidebar__close:hover {
      color: #636f7f;
  }
  
  
  .datepicker,
  .timepicker {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
  }
  
  .omnica-button {
      --omnica-button-text-color: #1e2248;
      appearance: none;
      background-image: none;
      border: none;
      border-radius: 6px;
      box-sizing: border-box;
      color: var(--omnica-button-text-color);
      cursor: pointer;
      display: inline-block;
      font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
      line-height: normal;
      padding: 0 20px;
      text-align: center;
      text-decoration: none;
      touch-action: manipulation;
      transition: color .25s ease,background .25s ease,box-shadow .25s ease,border .25s ease,width 0s;
      user-select: none;
      vertical-align: top;
      white-space: nowrap;
  }
  
  .omnica-button_primary {
      --omnica-button-background-color: #005eeb;
      --omnica-button-background-color-active: #0052cc;
      --omnica-button-background-color-disabled: #b8dbff;
      --omnica-button-background-image: linear-gradient(180deg,#0068ff,#005bd5);
      --omnica-button-text-color: #fff;
      background-color: var(--omnica-button-background-color);
      background-image: var(--omnica-button-background-image);
      font-weight: 500;
      margin-left: 10px;
      color: #fff;
  }
  .omnica-button, .omnica-button:active, .omnica-button:focus {
      box-shadow: none;
      outline: none!important;
  }
  .omnica-button_secondary {
      background-color: #f4f6f8;
      background-image: linear-gradient(180deg,#fff,#e9ecee);
      border: 1px solid #dee2e6;
  }
  
  .omnica-button_sm {
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      height: 36px;
      line-height: normal;
      min-width: 96px;
      padding: 0 20px;
  }
  .omnica-button__inner {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      width: 100%;
  }
  
  .omnica-button_ellipsis .omnica-button__text {
      overflow: hidden;
      text-overflow: ellipsis;
  }
  
  .flatpickr {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
  }
  
  
  /* Анимация для выезда */
  .sidebar-slide-enter-active,
  .sidebar-slide-leave-active {
    transition: transform 0.3s ease-out;
  }
  
  .sidebar-slide-enter-from,
  .sidebar-slide-leave-to {
    transform: translateX(100%); /* Скрытое положение */
  }
  
  .sidebar-slide-enter-to,
  .sidebar-slide-leave-from {
    transform: translateX(0); /* Позиция видна */
  }


  .omnica-button__inner {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.omnica-button_sm .omnica-button__icon {
    height: 20px;
    min-width: 20px;
    width: 20px;
}

.omnica-button_ellipsis .omnica-button__text {
    overflow: hidden;
    text-overflow: ellipsis;
}

.omnica-button_sm {
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    height: 36px;
    line-height: normal;
    min-width: 96px;
    padding: 0 20px;
}

.omnica-button_secondary {
    background-color: #f4f6f8;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
}


.sidebar-panel {
    background: #f4f6f8;
    display: flex;
    padding: 8px 32px;
}


.sidebar-body__inner {
    padding: 20px 32px;
}

.bubble-item__row {
    display: flex;
    margin-top: 8px;
}

.buble-info{
    align-items: center;
    display: flex;
    margin-left: 16px;
}
.buble-info svg {
    fill: #c7cdd4;
    height: 20px;
    margin-right: 4px;
    width: 20px;
}
.buble-info:first-child {
    margin-left: 0px;
}
.bubble-item__body {
    background: #edf4ff;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    width: 100%;
}
.bubble-item__comment svg {
    fill: #c7cdd4;
    height: 20px;
    margin-left: 11px;
    transform: translateY(3px);
    transition: .2s ease;
    width: 20px;
    position: relative;
    top: -2px;
    vertical-align: top;
}
.bubble-cont {
    display: flex;
}

.taskitem {
    display: flex;
    align-items: center;
}
.dueData {
    text-align: center;
    color: #636f7f;
}

.icontask svg {
    fill: #c7cdd4;
    cursor: pointer;
    height: 24px;
    transition: .2s ease;
    width: 24px;
}
.icontask.act svg {
    fill: #22c993;
}
.icontask:hover svg {
    fill: #636f7f;
}

.bubble-cont .complited {
    color: #afb9c3;
    text-decoration: line-through;
}


/*  Кнопка */

.hid .switch {
  position: relative;
  display: inline-block;
  height: 25px;
  padding: 0 !important;
  min-width: 48px !important;
  margin-bottom: 0 !important;
}

.hid .switch input {display:none;}

.hid .sliderrr {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.hid .sliderrr:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 1px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.hid input:checked + .sliderrr {
  background-color: #2196F3;
}

.hid input:focus + .sliderrr {
  box-shadow: 0 0 1px #2196F3;
}

.hid input:checked + .sliderrr:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.hid .sliderrr.round {
  border-radius: 34px;
}

.hid .sliderrr.round:before {
  border-radius: 50%;
}
.hid {
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
  </style>
  